import {
  Link,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import React, { useState } from 'react';
import {
  AiOutlineUser,
  AiOutlineHeart,
  AiOutlineShoppingCart,
  AiOutlineClose,
} from 'react-icons/ai';
import LogoImage from '../assets/img/logo/glorious_1.webp';
import { useSelector } from 'react-redux';


const Navbar = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [language, setLanguage] = useState('English');
  const location = useLocation();
  const { cart } = useSelector((state) => state.user_cart);
  const { wish_list } = useSelector((state) => state.user_wish_list);


  const navItems = [
    { title: 'Home', url: '/' },
    { title: 'Shop', url: '/shop' },
    { title: 'Blog', url: '/blog' },
    { title: 'About Us', url: '/about_us' },
    { title: 'Contact', url: '/contact_us' },
  ];



  const navigation = useNavigate();


  return (
    <div className="w-full sticky top-0 left-0 z-50 bg-white shadow-md">
      {/* Main Navbar */}
      <div className="border-b">
        <div className="container mx-auto px-4 py-4">
          <div className="flex items-center justify-between gap-8">
            {/* Logo */}
            <div className="sm:w-48 w-32 flex-shrink-0">
              <Link to="/">
                <img src={LogoImage} alt="logo" />
              </Link>
            </div>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center justify-center flex-grow gap-16">
              {navItems.map((item) => (
                <div key={item.title} className="relative group">
                  <Link
                    to={item.url}
                    className={`text-[#666666] text-[1.8rem] leading-9  hover:text-red-500 ${location.pathname === item.url
                        ? 'border-b-2 border-red-500 text-red-500 pb-1'
                        : ''
                      }`}
                  >
                    {item.title}
                  </Link>
                </div>
              ))}
            </nav>

            {/* Right Icons */}
            <div className="flex items-center gap-6">

              <button
                onClick={() => {
                  navigation('/auth/signin');
                }}
                className="hidden lg:block hover:text-primary transition-colors"
              >
                <AiOutlineUser className="text-2xl h-8 w-8" />
              </button>
              <button className="flex items-center hover:text-primary transition-colors">
  <div className="relative">
    <Link to="/wishlist">
      <AiOutlineHeart className="text-2xl h-8 w-8 mt-2" />
      <span className="absolute top-1 -right-2 text-xs bg-red-500 text-white p-2 rounded-full h-4 w-4 flex items-center justify-center">
        {wish_list?.products?.length || 0} 
      </span>
    </Link>
  </div>
</button>
<button className="flex items-center hover:text-primary transition-colors">
  <div className="relative">
    <Link to="/cart">
      <AiOutlineShoppingCart className="text-2xl h-8 w-8 mt-2" />
      <span className="absolute top-1 -right-2 text-xs bg-red-500 text-white p-2 rounded-full h-4 w-4 flex items-center justify-center">
        {cart?.products?.length || 0}
      </span>
    </Link>
  </div>
</button>

              {/* Mobile Menu Button */}
              <button
                className="lg:hidden"
                onClick={() => setIsMobileMenuOpen(true)}
              >
                <div className="space-y-1">
                  <span className="block w-6 h-0.5 bg-gray-700"></span>
                  <span className="block w-6 h-0.5 bg-gray-700"></span>
                  <span className="block w-6 h-0.5 bg-gray-700"></span>
                </div>
              </button>
            </div>
          </div>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div
          className="fixed inset-0 bg-black/50 z-40 lg:hidden"
          onClick={() => setIsMobileMenuOpen(false)}
        />
      )}

      {/* Mobile Menu */}
      {isMobileMenuOpen && (
        <div className="fixed inset-0 bg-white z-50 lg:hidden md:ml-[38.4rem] ml-[19.4rem]">
          <div className="p-4">
            <div className="flex justify-between items-center mb-8">
              <div className="w-32">
                <img src={LogoImage} alt="logo" />
              </div>
              <button
                onClick={() => setIsMobileMenuOpen(false)}
                className="p-2"
              >
                <AiOutlineClose className="text-2xl" />
              </button>
            </div>

            <nav className="space-y-12">
              {navItems.map((item) => (
                <div key={item.title} className="border-b border-gray-100">
                  <Link
                    to={item.url}
                    className={`text-[#666666] text-[1.5rem] leading-5  hover:text-red-500 ${location.pathname === item.url
                        ? 'border-b-2 border-red-500 text-red-500 pb-1'
                        : ''
                      }`}
                  >
                    {item.title}
                  </Link>
                </div>
              ))}
            </nav>

            <div className="mt-8 space-y-4">
              <button
                onClick={() => {
                  navigation('/auth/signin');
                }}
                className="flex items-center gap-2 text-gray-600"
              >
                <AiOutlineUser className="text-xl" />
                <span>Login / Register</span>
              </button>

              <div className="space-y-2 md:w-[37rem] w-[14rem]">
                <select
                  className="block w-full p-2 border rounded"
                  value={language}
                  onChange={(e) => setLanguage(e.target.value)}
                >
                  <option value="English">English</option>
                  {/* Add more language options */}
                </select>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
